import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router/dom";
import { AuthProvider } from "@/shared/auth/AuthProvider";
import { AiTranslateAction } from "@/shared/ai";
import { LocalizedInputActionContext, ToastProvider } from "@/shared/ui";
import { queryClient } from "./queryClient";
import type { LocalizedInputActionProps } from "@/shared/ui";
import { router } from "./router";

const translateAction = (p: LocalizedInputActionProps) => <AiTranslateAction {...p} />;

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastProvider>
          {/* AI group G: "Dịch tự động" on every localized field. */}
          <LocalizedInputActionContext.Provider value={translateAction}>
            <RouterProvider router={router} />
          </LocalizedInputActionContext.Provider>
        </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
